<template>
  <v-container>
    <v-row class="d-flex flex-column px-4">
      <v-col class="pa-0" v-for="(item, i) in setAlertsOfSite()" :key="i">
        <v-alert
          v-if="item.isVisible"
          transition="scroll-x-transition"
          :color="item.color"
          dismissible
          class="white--text"
          max-width="600"
        >
          <v-row class="d-flex align-center">
            <v-col cols="1" :class="!$vuetify.breakpoint.smAndDown || 'pl-0'">
              <v-icon
                v-if="!$vuetify.breakpoint.smAndDown"
                size="30"
                color="white"
              >
                {{ item.icon }}
              </v-icon>
              <v-btn v-else :href="item.link" icon>
                <v-icon color="white">{{ item.icon }}</v-icon>
              </v-btn>
            </v-col>
            <v-col
              cols="11"
              class="d-flex flex-column"
              :class="
                !$vuetify.breakpoint.smAndDown || 'flex-column text-center'
              "
            >
              <span
                class="font-weight-bold"
                :class="!$vuetify.breakpoint.smAndDown || 'phone-view'"
              >
                {{ item.message }}
              </span>
              <div
                class="d-flex justify-end"
                v-if="!$vuetify.breakpoint.smAndDown && item.link !== ''"
              >
                <v-btn
                  small
                  outlined
                  color="white"
                  v-if="!item.hideButton"
                  :href="item.link"
                >
                  {{ item.buttonMessage }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { isAEMOrganization } from '../../share/validateOrganization';
import { isAsofomOrganization } from '@/share/imef';
import { colors } from '@/constants/colors.js';
import { isAmpiOrganizationUser } from '@/common/ampiOrganizationUserAccess';

export default {
  props: {
    loggedAccount: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      user: { ...this.loggedAccount },
      color: colors,
    };
  },
  methods: {
    isAEMOrganization,
    $_alertConstructor({
      color = '',
      message = '',
      icon = 'mdi-alert',
      link = '/mi-cuenta',
      buttonMessage = 'Integrar',
      isVisible = false,
    }) {
      return {
        isVisible,
        color: color || this.color.secondary,
        message,
        icon,
        link,
        buttonMessage,
      };
    },

    allowedUserRoles(roles = ['HEAD_OFFICE', 'ORGANIZATION', 'BRANCH']) {
      return roles.includes(this.user.role) ||
        (roles.includes('HEAD_OFFICE') && isAmpiOrganizationUser(this.user));
    },

    isAccountSetupNotStarted() {
      return this.user?.accountSetup == 'NOT_STARTED';
    },

    isNotExpressAccount() {
      return (
        this.user?.stripeAccountType != 'EXPRESS' ||
        !this.user.stripeAccountType
      );
    },

    // hide alert for these organizations
    isNotValidOrganization() {
      const _id = this.user?._id || null;
      return this.isAEMOrganization(_id);
    },

    isAsofomChapterBranch() {
      return (
        this.user?.role === 'BRANCH' &&
        isAsofomOrganization(this.user?._id, this.user?.headOffice)
      );
    },

    setAlertsOfSite() {
      return [
        this.$_alertConstructor({
          message: 'Recuerda actualizar los datos de tu cuenta bancaria',
          buttonMessage: 'Actualizar',
          color: 'red',
          isVisible:
            !this.isNotValidOrganization() &&
            this.allowedUserRoles() &&
            !this.isAccountSetupNotStarted() &&
            this.isNotExpressAccount(),
        }),
        this.$_alertConstructor({
          message: 'Requiere integración de cuenta bancaria',
          isVisible:
            !this.isAsofomChapterBranch() &&
            this.allowedUserRoles() &&
            this.isAccountSetupNotStarted(),
        }),
        this.$_alertConstructor({
          alertColor: 'red',
          message:
            'Esta organización aún no integra sus sellos y/o datos fiscales para ofrecer facturación',
          icon: 'mdi-alert-circle',
          isVisible:
            !this.isAsofomChapterBranch() &&
            !this.isNotValidOrganization() &&
            this.allowedUserRoles() &&
            !this.user.invoiceSetup,
        }),
        this.$_alertConstructor({
          message:
            'No olvides cargar tus datos fiscales, editándolos en tu perfil, para que cuando requieras factura se carguen de forma automática',
          link: '/member/home/?tab=2',
          isVisible:
            this.allowedUserRoles(['MEMBER', 'MEMBERSHIP_USER']) &&
            this.$router.name == 'Renew Membership' &&
            (!this.user.fiscalData ||
              Object.values(this.user.fiscalData).some((data) => data === '')),
          buttonMessage: 'CARGAR DATOS',
        }),
      ];
    },
  },
};
</script>
<style scoped>
.phone-view {
  font-size: 12px;
  margin-bottom: 10px;
}
</style>
